// ======================================================================
// File: src/modules/ppe/pages/procurement/purchase-return/services/purchaseReturnService.js
// Module: PPE → Procurement → Purchase Return
//
// Purpose:
// - API service for Purchase Return
// - Handles list, detail, create and workflow API calls
// - Follows existing GRN service pattern
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow/purchase-return";

const purchaseReturnService = {

  // --------------------------------------------------------
  // LIST
  // --------------------------------------------------------
  getPurchaseReturnList: async (params = {}) => {
    const response = await axiosClient.get(BASE_URL, {
      params,
    });

    return response.data;
  },

  // --------------------------------------------------------
  // DETAIL
  // --------------------------------------------------------
  getPurchaseReturn: async (id) => {
    const response = await axiosClient.get(
      `${BASE_URL}/${id}`
    );

    return response.data;
  },

  // --------------------------------------------------------
  // CREATE HEADER
  // --------------------------------------------------------
  createPurchaseReturn: async (payload) => {
    const response = await axiosClient.post(
      BASE_URL,
      payload
    );

    return response.data;
  },

  // --------------------------------------------------------
  // ADD LINE
  // --------------------------------------------------------
  addPurchaseReturnLine: async (id, payload) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${id}/lines`,
      payload
    );

    return response.data;
  },

  // --------------------------------------------------------
  // SUBMIT FOR APPROVAL
  // --------------------------------------------------------
  submitForApproval: async (id) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${id}/submit-for-approval`
    );

    return response.data;
  },

  // --------------------------------------------------------
  // POST PURCHASE RETURN
  // --------------------------------------------------------
  postPurchaseReturn: async (id) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${id}/post`
    );

    return response.data;
  },

  // --------------------------------------------------------
  // CANCEL
  // --------------------------------------------------------
  cancelPurchaseReturn: async (id, payload = {}) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${id}/cancel`,
      payload
    );

    return response.data;
  },

  // --------------------------------------------------------
  // GET RETURNABLE QUANTITY
  // --------------------------------------------------------
  getReturnableQuantity: async (grnLineId, returnSource) => {
    const response = await axiosClient.get(
      `${BASE_URL}/returnable-quantity`,
      {
        params: {
          grn_line_id: grnLineId,
          return_source: returnSource,
        },
      }
    );

    return response.data;
  },
};

export default purchaseReturnService;